/* eslint no-console: 0 */

<template>
  <li class="mini-cart__product">
    <button
      class="remove-from-cart remove"
      type="button"
      @click="destroyLineItem"
    >
      <svg viewBox="0 0 16 16" aria-hidden="true">
        <path d="M2 2l12 12M14 2L2 14" fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="1.5" />
      </svg>
      <span class="uk-shell-sr-only">Удалить</span>
    </button>

    <div class="mini-cart__product__image">
      <img
        v-if="product.imageUrl"
        :src="product.imageUrl"
        :srcset="product.imageSrcset"
        sizes="100px"
        :width="product.imageWidth"
        :height="product.imageHeight"
        :alt="product.name"
      >
      <div v-else class="checkout-summary-item__placeholder">Товар</div>
    </div>

    <div class="mini-cart__product__content">
      <a
        class="mini-cart__product__title"
        :href="product.defaultUrl"
      >
        {{ product.name }}
      </a>

      <span
        v-show="!preorder()"
        class="mini-cart__product__price"
      >{{ product.price }} ₽</span>

      <template v-if="preorder()">
        <b class="mini-cart__product__price mini-cart__product__price--preorder">
          Предзаказ
        </b>
      </template>


      <template v-if="hasVariant()">
        <div
          v-if="hasVariant()"
          class="mini-cart__product__option"
        >
          {{ variantName() }}
        </div>
      </template>
    </div>
  </li>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      required: true
    },
    product: {
      type: Object,
      required: true
    },
    selectedVariant: {
      type: Object,
      default: null
    }
  },
  emits: ['destroy-line-item'],
  methods: {
    destroyLineItem: function() { this.$emit('destroy-line-item', this.id); },

    variantName: function() {
      const color = this.selectedVariant.color?.name || '';
      const size = this.selectedVariant.option.value || '';
      const cupSize = this.selectedVariant.cupSize || '';
      let result = '';

      if (size != '') {
        result = `${this.selectedVariant.option.shortName}: ${size}`;
      }

      result += cupSize;

      if (color != '') {
        result += ` ${color}`;
      }

      return result;
    },

    hasVariant: function() {
      return this.selectedVariant !== null;
    },

    preorder: function() { return (this.product.status == 'soon_in_stock'); },
  }
};
</script>
